/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { AddressDetails__AddressFragmentDoc } from '../addresses/Addresses.generated.js';
import { AttachmentSnapshotFragmentDoc, ProductAttachmentSnapshotFragmentDoc, AttachmentsFragmentDoc, WithItemAttachmentsFragmentDoc } from '../attachments/Attachments.generated.js';
export type ScheduleListProjectFragment = { __typename: 'Project', id: string, title: string, ticket: boolean, owningSystemOrganisationId: string, viewerPermissions: Array<Types.PermissionName>, buildingInfo?: { __typename: 'BuildingInfo', id: string, title: string, buildingAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null } | null };

export type ScheduleWhoFragment = { __typename: 'User', id: string, firstname: string, familyname: string, fullname: string, avatar?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null };

export type ScheduleProjectFragment = { __typename: 'Project', id: string, title: string, ticket: boolean, earliestStart?: any | null, deadline?: any | null, viewerPermissions: Array<Types.PermissionName>, buildingInfo?: { __typename: 'BuildingInfo', id: string, title: string, buildingAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null } | null };

export type SchedulePlanSessionFragment = { __typename: 'PlanSession', id: string, from: any, till: any, isTentative: boolean, roles: Array<{ __typename: 'ProjectRole', internalName: string, label: string, id: string }>, who: { __typename: 'User', id: string, firstname: string, familyname: string, fullname: string, avatar?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null }, project: { __typename: 'Project', id: string, title: string, ticket: boolean, earliestStart?: any | null, deadline?: any | null, viewerPermissions: Array<Types.PermissionName>, buildingInfo?: { __typename: 'BuildingInfo', id: string, title: string, buildingAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null } | null } };

export const ScheduleListProjectFragmentDoc = gql`
    fragment ScheduleListProject on Project {
  id
  title
  ticket
  owningSystemOrganisationId
  viewerPermissions
  buildingInfo {
    id
    title
    buildingAddress {
      ...AddressDetails__Address
    }
  }
}
    ${AddressDetails__AddressFragmentDoc}`;
export const ScheduleWhoFragmentDoc = gql`
    fragment ScheduleWho on User {
  id
  firstname
  familyname
  fullname
  avatar {
    ...AttachmentSnapshot
  }
}
    ${AttachmentSnapshotFragmentDoc}`;
export const ScheduleProjectFragmentDoc = gql`
    fragment ScheduleProject on Project {
  id
  title
  ticket
  earliestStart
  deadline
  viewerPermissions
  buildingInfo {
    id
    title
    buildingAddress {
      ...AddressDetails__Address
    }
  }
}
    ${AddressDetails__AddressFragmentDoc}`;
export const SchedulePlanSessionFragmentDoc = gql`
    fragment SchedulePlanSession on PlanSession {
  id
  from
  till
  roles {
    internalName
    label
    id
  }
  who {
    id
    ...ScheduleWho
  }
  project {
    id
    ...ScheduleProject
  }
  isTentative
}
    ${ScheduleWhoFragmentDoc}
${ScheduleProjectFragmentDoc}`;